import { ArrayOrBase64 } from 'vault-crypto';

import { uint8ArraySchema } from './uint8ArraySchema';

export function brandedUint8Array<T extends Uint8Array>(loader: (data: ArrayOrBase64) => T) {
  return uint8ArraySchema.transform((arr) => loader(arr));
}
